import TableToolbar from '@rio-cloud/rio-uikit/TableToolbar';
import { ReactElement } from 'react';
import { ServiceOrderCategoriesSelection } from './ServiceOrderCategoriesSelection';
import { ServiceOrderFilterModal } from './ServiceOrderFilterModal';
import { TableViewOptions } from '../../../sharedComponents/TableViewOptions';
import { TableColumnSettings } from '../../../sharedComponents/table/TableColumnSettings';

type ServiceOrderTableToolbarProps = {
    statusFilter: ReactElement;
    search: ReactElement;
    bulkUpdate?: ReactElement;
    exportModal?: ReactElement;
};

export const ServiceOrderTableToolbar = ({
    statusFilter,
    search,
    bulkUpdate,
    exportModal,
}: ServiceOrderTableToolbarProps) => (
    <TableToolbar>
        <div className="table-toolbar-container">
            <div className="table-toolbar-group-left">
                <div className="table-toolbar-column">
                    <div className="btn-toolbar table-btn-toolbar">
                        <ServiceOrderCategoriesSelection />
                    </div>
                </div>
            </div>
            <div className="table-toolbar-group-right">
                {bulkUpdate && <div className="table-toolbar-column table-toolbar-column-spacer">{bulkUpdate}</div>}
                <div className="table-toolbar-column min-width-300">{statusFilter}</div>
                <div className="table-toolbar-column">
                    <ServiceOrderFilterModal />
                </div>
                <div className="table-toolbar-column">{search}</div>
                {exportModal && <div className="table-toolbar-column">{exportModal}</div>}
                <div className="table-toolbar-column">
                    <TableViewOptions />
                </div>
                <div className="table-toolbar-column">
                    <TableColumnSettings />
                </div>
            </div>
        </div>
    </TableToolbar>
);
